export const createFeedbackOptions = {
  props: ({mutate}) => ({
    createFeedbackMutation: variables => {
      return mutate({
        variables
      });
    }
  })
};
